// @ts-nocheck
/* eslint-disable */
import {
  takeLatest,
  take,
  call,
  put,
  fork,
  cancel,
  select,
} from 'redux-saga/effects';
import { API_URL as API_URI } from 'config/constants';
import * as types from '../actions/project_budget';
import * as services from 'utils/apiHelper';

function* getBudget(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/project-total/?project_id=${payload.project_id}`,
    token,
  );

  if (data) {
    yield put({ type: types.GET_PROJECT_BUDGET_SUCCESS, payload: data });
  }
}
function* budgetWatcher() {
  yield takeLatest(types.GET_PROJECT_BUDGET_REQUEST, getBudget);
}

export default budgetWatcher;
